import React from 'react';
import css from './style.module.css';
import CopyButton from './CopyButton';
import { roleLabels } from './hqApi';

export default function CredentialsResults({ results, org, onRetryFailed, onNewBatch }) {
    const created = results?.created || [];
    const failed = results?.failed || [];
    const withPassword = created.filter((user) => user.password);
    const portalUrl = org?.companyDomain || '';

    const rowText = (user) => `Email: ${user.email}\nPassword: ${user.password}`;

    const allText = () =>
        withPassword
            .map((user) => `Portal: ${portalUrl}\nEmail: ${user.email}\nPassword: ${user.password}`)
            .join('\n\n');

    return (
        <div>
            {withPassword.length > 0 && (
                <div className={css.warnBanner} role="alert">
                    <i className="fa-solid fa-triangle-exclamation mt-1" aria-hidden="true"></i>
                    <span>
                        These passwords are shown only once. Copy them now — you cannot retrieve
                        them later (only reset).
                    </span>
                </div>
            )}

            <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
                <div>
                    <strong>{results?.message}</strong>
                    <div className={css.tempPasswordNote}>
                        Users will be asked to set a new password on first sign-in.
                    </div>
                </div>
                {withPassword.length > 0 && (
                    <CopyButton
                        getText={allText}
                        label="Copy all credentials"
                        className={`btn btn-sm ${css.btnPrimary}`}
                    />
                )}
            </div>

            {created.length > 0 && (
                <table className="rounded-table">
                    <thead className="table-header">
                        <tr>
                            <th className="py-1 px-2">Name</th>
                            <th className="py-1 px-2">Email</th>
                            <th className="py-1 px-2">Role</th>
                            <th className="py-1 px-2">Password</th>
                            <th className="py-1 px-2"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {created.map((user) => (
                            <tr key={user.uid} className="table-row">
                                <td className="py-1 px-2">{user.name}</td>
                                <td className="py-1 px-2">{user.email}</td>
                                <td className="py-1 px-2">
                                    <span className={css.roleBadge}>{roleLabels[user.role] || user.role}</span>
                                </td>
                                <td className="py-1 px-2">
                                    {user.alreadyHadPassword ? (
                                        <span className={css.noPassword}>
                                            Existing account — no new password
                                        </span>
                                    ) : (
                                        <span className={css.password}>{user.password}</span>
                                    )}
                                </td>
                                <td className="py-1 px-2">
                                    {!user.alreadyHadPassword && (
                                        <CopyButton getText={() => rowText(user)} />
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}

            {failed.length > 0 && (
                <div className={css.failedBox}>
                    <div className={css.failedTitle}>
                        <i className="fa-solid fa-circle-exclamation me-1" aria-hidden="true"></i>
                        {failed.length} row{failed.length === 1 ? '' : 's'} failed
                    </div>
                    {failed.map((row, index) => (
                        <div className={css.failedRow} key={`${row.email}-${index}`}>
                            <strong>{row.email}</strong>
                            <span className={css.failedReason}>— {row.reason}</span>
                        </div>
                    ))}
                    <button
                        type="button"
                        className="btn btn-sm btn-outline-danger mt-2"
                        onClick={onRetryFailed}
                    >
                        <i className="fa-solid fa-rotate-right me-1" aria-hidden="true"></i>
                        Retry failed rows
                    </button>
                </div>
            )}

            <div className="mt-4">
                <button type="button" className="btn btn-outline-secondary" onClick={onNewBatch}>
                    Create another batch
                </button>
            </div>
        </div>
    );
}
